module.exports = __webpack_public_path__ + "static/media/phone.61da97d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Glasses/phone.mp4
// module id = ckSc
// module chunks = 1